import React, { useCallback, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useModal } from '../../hooks/modal';

import { Container, TextContent, Logo } from './styles';
import { FuzzyLogoNewOrange } from '../../assets/svg/SVGComponents';
import { useToast } from '../../hooks/toast';

const PrivacyPolicyModal: React.FC = () => {
  const { closeModal } = useModal();
  const [privacyText, setPrivacyText] = useState<string>('');
  const { t } = useTranslation();
  const { addToast } = useToast();

  /**
   * `privacy-policy.privacy-cookies` é a URL do markdown, não o texto. O estado
   * começa vazio e só recebe o conteúdo baixado: antes a URL era jogada direto
   * no estado e o modal chegava a exibi-la como se fosse a política — uma linha
   * enorme, sem espaços, no lugar do documento.
   */
  const loadDescriptionMarkdown = useCallback(async () => {
    try {
      const response = await fetch(t('privacy-policy.privacy-cookies'));

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      setPrivacyText(await response.text());
    } catch (error) {
      addToast({
        type: 'error',
        expression: 'Ops!',
        description: t('toasts.errors.load_description_fail'),
      });
    }
  }, [addToast, t]);

  useEffect(() => {
    loadDescriptionMarkdown();
  }, [loadDescriptionMarkdown]);

  return (
    <Container>
      <Logo>
        <FuzzyLogoNewOrange />
      </Logo>
      <TextContent>
        <div>
          <ReactMarkdown plugins={[gfm]} className="markdown-container">
            {privacyText}
          </ReactMarkdown>
        </div>
      </TextContent>

      <PrimaryButton
        onClick={() => {
          closeModal();
        }}
      >
        Voltar
      </PrimaryButton>
    </Container>
  );
};
export default PrivacyPolicyModal;
